import './tabs.sass';

export { default } from './tabs';
